import { render, staticRenderFns } from "./BookingWidgetLegacy.vue?vue&type=template&id=752556f8"
import script from "./BookingWidgetLegacy.vue?vue&type=script&lang=js"
export * from "./BookingWidgetLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports